import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import Text from './Text'

export const StyledText = styled(
  ({ color, fontSize, fontFamily, fontWeight, fontHeight, ...rest }) => (
    <Text {...rest} />
  )
)`
  display: inline-flex;
  color: ${({ color }) => color};
  font-size: ${({ fontSize }) => fontSize};
  font-family: ${({ fontFamily }) => fontFamily};
  font-weight: ${({ fontWeight }) => fontWeight};
  line-height: ${({ fontHeight }) => fontHeight};
`

StyledText.propTypes = {}
